module.exports = __webpack_public_path__ + "img/Meetlogo.dcbd4dcb.svg";